import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline caching and faster image loading
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ App is now ready for offline use!');
  },
  onUpdate: (registration) => {
    console.log('🔄 New version available! Refresh to update.');
    // Optionally show a notification to the user
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
